import React, { useState } from 'react';
import styles from './EmailForm.module.css';
import validate from '../../common/utils/validate';
import axios from 'axios';

const EmailForm = () => {
    const [emailData, setEmailData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        subject: '',
        message: ''
    });
    const [errors, setErrors] = useState({});
    const [showErrors, setShowErrors] = useState(false);
    const [showMsg, setShowMsg] = useState(false);
    const [showFailedDelivery, setShowFailedDelivery] = useState(false);

    function handleChange(e) {
        setEmailData({
            ...emailData,
            [e.target.name]: e.target.value
        })
        setErrors(validate({
            ...emailData,
            [e.target.name]: e.target.value
        }))        
    }

    async function handleSubmit(e) {
        e.preventDefault();
        const validation = validate(emailData);

        if (Object.keys(validation).length === 0) {
            try {
                const sendEmail = axios.post('/send-email', emailData);

                setEmailData({
                    firstName: '',
                    lastName: '',
                    email: '',
                    subject: '',
                    message: ''
                });
        
                setShowMsg(true);
                setTimeout(() => {
                    setShowMsg(false);
                }, 5000);
            } catch(e) {
                console.log(e);
                setShowFailedDelivery(true);
                setTimeout(() => {
                    setShowFailedDelivery(false);
                }, 5000);

            }
        } else {
            setErrors(validation);
            setShowErrors(true);
        }
    }

    return (
        <div className={styles.container}>
            <h2 className={styles.header}>04. Contact</h2>
            <h2 className={styles.title}>LET'S TALK</h2>
            <form id="contact" className={styles.form} onSubmit={e => handleSubmit(e)}>
                <div className={styles.fieldsContainer}>
                    <div 
                        data-error={errors.firstName  && showErrors ? errors.firstName : null} 
                        className={styles.inputContainer}
                    >
                        <input
                            className={`${styles.input} ${errors.firstName && showErrors ? styles.error : null}`}
                            name="firstName"
                            type="text"
                            placeholder="FIRST NAME*"
                            value={emailData.name}
                            onChange={e => handleChange(e)}
                        />
                    </div>
                    <div 
                        data-error={errors.lastName && showErrors ? errors.lastName : null} 
                        className={styles.inputContainer}
                    >
                        <input
                            className={`${styles.input} ${errors.lastName && showErrors ? styles.error : null}`}
                            name="lastName"
                            type="text"
                            placeholder="LAST NAME*"
                            value={emailData.lastName}
                            onChange={e => handleChange(e)}
                        />
                    </div>
                </div>
                <div className={styles.fieldsContainer}>
                    <div 
                        data-error={errors.email && showErrors ? errors.email : null} 
                        className={styles.inputContainer}
                    >
                        <input
                            className={`${styles.input} ${errors.email && showErrors ? styles.error : null}`}
                            name="email"
                            type="text" 
                            placeholder="EMAIL*"
                            value={emailData.email}
                            onChange={e => handleChange(e)}
                        />
                    </div>
                    <div className={styles.inputContainer}>
                        <input
                            className={styles.input}
                            name="subject"
                            type="text" 
                            placeholder="SUBJECT"
                            value={emailData.subject}
                            onChange={e => handleChange(e)}
                        />
                    </div>
                </div>
                <div 
                    data-error={ errors.message && showErrors ? errors.message : null}
                    className={`
                        ${styles.textAreaContainer} 
                        ${showMsg ? styles.textAreaContainerOkMsg : null}
                        ${showFailedDelivery ? styles.textAreaContainerErrorMsg : null}
                    `}>
                    <textarea
                        className={`${styles.textArea} ${errors.message && showErrors ? styles.error : null}`}
                        name="message"
                        type="textarea"
                        placeholder="MESSAGE*"
                        value={emailData.message}
                        onChange={e => handleChange(e)}
                    />
                </div>
                <button className={styles.btn} type="submit">SEND MESSAGE</button>
            </form>
        </div>
    )
}

export default EmailForm;
